import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './PageNotFound.css';

const PageNotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | Nutrivio Medical Services</title>
        <meta
          name="description"
          content="The page you are looking for does not exist or has been moved. Explore Nutrivio's medical college establishment and institutional advisory services."
        />
      </Helmet>

      <div className="page-not-found-wrapper">
        
        {/* Ambient Glow & Dot Matrix */}
        <div className="page-not-found-ambient-pattern"></div>
        <div className="page-not-found-ambient-glow"></div>

        <div className="page-not-found-container">
          
          <div className="page-not-found-card">
            
            {/* Top Accent Hover Line */}
            <div className="page-not-found-accent-bar"></div>

            {/* Symmetrical Eyebrow Header */}
            <div className="page-not-found-eyebrow">
              <span className="page-not-found-eyebrow-dash"></span>
              <span>Error 404 &bull; Resource Unavailable</span>
              <span className="page-not-found-eyebrow-dash"></span>
            </div>

            {/* 3D-Style Layered 404 Visual Glyph */}
            <div className="page-not-found-visual-stage">
              <div className="page-not-found-num-stack">
                <span className="page-not-found-layer layer-3">404</span>
                <span className="page-not-found-layer layer-2">404</span>
                <span className="page-not-found-layer layer-1">404</span>
                <span className="page-not-found-main-glyph">404</span>
              </div>
            </div>

            {/* Main Headline & Narrative */}
            <h1 className="page-not-found-title">
              Page Not Found
            </h1>

            <p className="page-not-found-desc">
              The page you are looking for might have been moved, renamed, or is temporarily unavailable. Let us guide you back to our institutional advisory portals and healthcare resources.
            </p>

            {/* Primary & Secondary Action Buttons */}
            <div className="page-not-found-btn-row">
              <Link to="/" className="page-not-found-btn-primary">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                  <polyline points="9 22 9 12 15 12 15 22"/>
                </svg>
                <span>Return to Homepage</span>
              </Link>

              <Link to="/services" className="page-not-found-btn-secondary">
                <span>Explore Services</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </Link>
            </div>

            {/* Quick Navigation Destination Hub */}
            <div className="page-not-found-quick-hub">
              <span className="page-not-found-quick-title">Popular Institutional Portals</span>
              
              <div className="page-not-found-quick-links-grid">
                <Link to="/about" className="page-not-found-quick-item">
                  <span className="page-not-found-item-bullet">&bull;</span>
                  <span>About Nutrivio</span>
                </Link>

                <Link to="/gallery" className="page-not-found-quick-item">
                  <span className="page-not-found-item-bullet">&bull;</span>
                  <span>Visual Showcase</span>
                </Link>

                <Link to="/for-institutions" className="page-not-found-quick-item">
                  <span className="page-not-found-item-bullet">&bull;</span>
                  <span>For Institutions</span>
                </Link>

                <Link to="/for-medical-faculty" className="page-not-found-quick-item">
                  <span className="page-not-found-item-bullet">&bull;</span>
                  <span>Medical Faculty</span>
                </Link>

                <Link to="/contact" className="page-not-found-quick-item">
                  <span className="page-not-found-item-bullet">&bull;</span>
                  <span>Contact Desk</span>
                </Link>
              </div>
            </div>

          </div>

        </div>

      </div>
    </>
  );
};

export default PageNotFound;